import dashboard from './user/dashboard'
import devices from './user/devices'
import watches from './user/watches'
import alerts from './user/alerts'
import myidicare from './user/myidicare'
import account from './user/account'

export default [
	...myidicare,
	...dashboard,
	...devices,
	...watches,
	...alerts,
	...account
]



// WEBPACK FOOTER //
// ./src/router/modules/user.js